import {Component} from '@angular/core';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
})
export class AppComponent {

    public constructor(
        private _matIconRegistry: MatIconRegistry,
        private _domSanitizer: DomSanitizer,
        private _translateService: TranslateService,
    ) {
        this.registerSvgIcon();
    }

    private initTranslationService() {
        this._translateService.setDefaultLang('fr');
        // TODO: Get default language from user ?
    }

    private registerSvgIcon() {
        const icons = [
            'bin',
            'edit',
            'edit-gray',
            'user',
            'info',
            'pdf',
            'three-dots',
            'arrow-right',
            'properties',
            'search',
            'plus',
            'plus-circle',
            'plus-square',
            'filters',
            'calendar',
            'fill-data'
        ];

        icons.forEach(icon => {
            this._matIconRegistry.addSvgIcon(
                `total-${icon}`,
                this._domSanitizer.bypassSecurityTrustResourceUrl(`../../../../assets/icons/${icon}.svg`)
            );
        });
    }
}
